import { useEffect } from 'react';

const useTitle = (title) => {
    useEffect(() => {
        document.title = `${title} - TechSimpleICT`;
    }, [title])
};

export default useTitle;